'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  COMPATIBLE_ANY: null,
  COMPATIBLE_BLOG: null,
  COMPATIBLE_EMAIL: null,
  COMPATIBLE_PAGE: null
}));